import { Theme } from '@24i/nxg-sdk-photon';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { Breakpoint } from '@24i/nxg-sdk-gluons/src/utils/styles/constants';

import { DynaRowStyles } from '../types';
import { getTelegramTopGap } from '../utils/telegramGap';

const getDynaRowScreenStyles = (theme: Theme): DynaRowStyles => ({
    app: {
        backgroundColor: theme.color.background1,
        flex: 1,
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        marginTop: getTelegramTopGap(),
    },
    browseTitleContainer: {
        marginTop: 102,
        height: 63,
        paddingTop: 7,
        paddingBottom: 14,
        [`@media (max-width: ${Breakpoint.LM}px)`]: {
            paddingLeft: 20,
        },
        [`@media (min-width: ${Breakpoint.LM + 1}px) and (max-width: ${Breakpoint.XL}px)`]: {
            paddingLeft: 32,
        },
        [`@media (min-width: ${Breakpoint.XL + 1}px) and (max-width: ${Breakpoint.XXL}px)`]: {
            paddingLeft: 48,
        },
        [`@media (min-width: ${Breakpoint.XXL + 1}px)`]: {
            paddingLeft: '4%',
        },
    },
    heroSliderTitleContainer: {
        marginTop: 102,
        height: 63,
        paddingTop: 7,
        paddingBottom: 14,
        paddingLeft: 48,
        position: 'absolute',
        zIndex: 9999,
    },
    browseTitle: {
        // @ts-expect-error
        color: theme.color.textPrimary,
        ...getFont(theme, 'h2'),
    },
    holder: {
        flex: 1,
        flexDirection: 'column',
        backgroundColor: 'transparent',
    },
    wrapper: {
        flex: 1,
    },
    activityIndicator: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    noDataContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    noDataTextTitle: {
        color: theme.color.textPrimary,
        ...getFont(theme, 'h4'),
    },
    noDataTextSubtitle: {
        color: theme.color.textPrimary,
        ...getFont(theme, 'body2'),
    },
});

export default getDynaRowScreenStyles;
